import React, { useState } from 'react';
import AccordianDownIcon from '../../assets/AccordianDownIcon';
import AccordianDownIconDark from '../../assets/AccordianDownIconDark';
import AccordianUpIcon from '../../assets/AccordianUpIcon';
import AccordianUpIconDark from '../../assets/AccordianUpIconDark';
import EditIcon from '../../assets/EditIcon';
import EditIconDark from '../../assets/EditIconDark';
import useBgColorStore from '../../store/bgColor';
import AirCraftComplianceCard from './AirCraftComplianceCard';
import Accordion from '../../components/common/Accordian';
import { IEquipmentCompliance } from '../../type/equipmentCompliance';
import VeichleComplianceCard from './VeichleComplianceCard';

interface AirCraftComplianceListProps {
  complianceData: IEquipmentCompliance[];
  writePermissionForEquipmentCompliance?: boolean;
  refetchComplianceDetails: () => void;
  editPermissionForVeichleCompliance?:boolean
}

const VeichleAndComplianceList: React.FC<AirCraftComplianceListProps> = ({
  complianceData,
  writePermissionForEquipmentCompliance,
  refetchComplianceDetails,
  editPermissionForVeichleCompliance
}) => {
  const { bgColor } = useBgColorStore();
  const [editIndex, setEditIndex] = useState<number | null>(null);
  const [editedStaffIds, setEditedStaffIds] = useState<{
    [key: number]: number | undefined;
  }>({});
  const [showModal, setShowModal] = useState(false);
  return (
    <div className="mt-4">
      <Accordion
        title="Upcoming Vehicle & Trailer Compliance"
        iconOpen={
          <div>
            <div className="block dark:hidden">
              <AccordianDownIcon />
            </div>
            <div className="hidden dark:block">
              <AccordianDownIconDark />
            </div>
          </div>
        }
        iconClose={
          <div>
            <div className="block dark:hidden">
              <AccordianUpIcon />
            </div>
            <div className="hidden dark:block">
              <AccordianUpIconDark />
            </div>
          </div>
        }
        bgColor={bgColor}
        accordionIsOpen={true}
      >
        {complianceData.map((item, index) => (
          <Accordion
            key={index}
            title={item?.equipmentName}
            bgColor="bg-backgroundColor-darkThemeColor"
            icon={
              writePermissionForEquipmentCompliance ? (
                <div>
                  <div className="block dark:hidden">
                    <EditIcon
                      onClick={() =>
                        setEditIndex((prev) => (prev === index ? null : index))
                      }
                    />
                  </div>
                  <div className="hidden dark:block">
                    <EditIconDark
                      onClick={() =>
                        setEditIndex((prev) => (prev === index ? null : index))
                      }
                    />
                  </div>
                </div>
              ) : undefined
            }
          >
            <VeichleComplianceCard
              compliance={item?.complianceGroupDescription}
              category={item?.equipmentTypeDescription}
              status={item?.status}
              allocatedTo={item?.allocatedStaffName}
              nextComplianceDateDisplay={item?.nextComplianceDateDisplay}
              complianceDescription={item?.complianceDescription}
              isEditable={editIndex === index}
              allocatedStaffId={editedStaffIds[index] ?? item?.allocatedStaffId}
              onStaffChange={(staffId) => {
                setEditedStaffIds((prev) => ({
                  ...prev,
                  [index]: staffId,
                }));
              }}
              nextComplianceDate={item?.nextComplianceDate}
              recurrency={item?.complianceFrequencyDescription}
              name={item?.equipmentTypeDescription}
              note={item?.equipmentComplianceNote || undefined}
              closeModal={() => setShowModal(false)}
              lastComplianceDateDisplay={item?.lastComplianceDateDisplay}
              complianceId={item?.complianceId}
              equipmentId={item?.equipmentId}
              equipmentTypeId={item.equipmentTypeId}
              refetchComplianceDetails={refetchComplianceDetails}
              complianceCategoryDescription={item?.complianceCategoryDescription}
              editPermissionForVeichleCompliance={editPermissionForVeichleCompliance}
              upcomingDays={item?.upcomingDays}

            />
          </Accordion>
        ))}
      </Accordion>
    </div>
  );
};

export default VeichleAndComplianceList;
